var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellNotification = function SvgBellNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 13.501h2M11.443 4.942a4.443 4.443 0 0 0-8.886 0v4.413c0 .442-.175.865-.488 1.178-.312.312-.627.488-1.069.488h12c-.442 0-.757-.176-1.07-.488a1.67 1.67 0 0 1-.487-1.178z"
  }))));
};
export default SvgBellNotification;